import { GMAP_OPTIONS, LOCALE } from '../static/config'

export const toggleBounce = (marker) => {
  marker.setAnimation(!marker.getAnimation() ? window.google.maps.Animation.BOUNCE : null)
}

export const gmapPolyline = (path, color) => {
  const _color = color || GMAP_OPTIONS.polylineDefault
  return new window.google.maps.Polyline({ path: path, strokeColor: _color, ...GMAP_OPTIONS.polylineStyle })
}

export const gmapPolylineLow = (path) => { return gmapPolyline(path, GMAP_OPTIONS.polylineDarkRed) }
export const gmapPolylineHigh = (path) => { return gmapPolyline(path, GMAP_OPTIONS.polylineDarkYellow) }
export const gmapPolylineMidLow = (path) => { return gmapPolyline(path, GMAP_OPTIONS.polylineRed) }
export const gmapPolylineMidHigh = (path) => { return gmapPolyline(path, GMAP_OPTIONS.polylineYellow) }

export const gmapMarkerSize = () => {
  return new window.google.maps.Size(...GMAP_OPTIONS.marker.size)
}

export const loadGoogleMaps = (callback) => {
  const existingScript = document.getElementById(GMAP_OPTIONS.gmapScriptId)

  if (!existingScript) {
    const script = document.createElement('script')
    const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY
    script.src = `${GMAP_OPTIONS.gmapBaseUrl}/api/js?key=${apiKey}&language=${LOCALE.locale}&region=${LOCALE.locale.toUpperCase()}`
    script.id = GMAP_OPTIONS.gmapScriptId
    script.async = true
    script.defer = true
    document.body.appendChild(script)
    script.onload = () => { if (callback) callback() }
  }

  if (existingScript && callback) callback()
}

export const removeGoogleMaps = () => {
  const mapScript = document.getElementById(GMAP_OPTIONS.gmapScriptId)

  if (mapScript) {
    mapScript.parentNode.removeChild(mapScript)

    const head = document.getElementsByTagName('head')[0]
    const scripts = head.getElementsByTagName('script')
    for (let i = 0; i < scripts.length; i++) {
      const script = scripts[i]
      const src = script.src

      if (src.startsWith(GMAP_OPTIONS.gmapBaseUrl)) {
        head.removeChild(script)
      }
    }
  }
}

export const patchGMapsApi = () => {
  window.google.maps.LatLng.prototype.distance = function (a) {
    const m = Math
    const ra = m.PI / 180
    const b = this.lat() * ra
    const c = a.lat() * ra
    const g = this.lng() * ra - a.lng() * ra
    const f = 2 * m.asin(m.sqrt(m.pow(m.sin((b - c) / 2), 2) + m.cos(b) * m.cos(c) * m.pow(m.sin(g / 2), 2)))
    return f * 6378.137 * 1000
  }

  window.google.maps.Polyline.prototype.meters = function (n) {
    let dist = 0
    const path = this.getPath(n)
    for (let i = 0; i < path.getLength() - 1; i++) {
      dist += path.getAt(i).distance(path.getAt(i + 1))
    }
    return dist
  }

  window.google.maps.Polyline.prototype.getPosition = function () {
    const path = this.getPath()
    const index = Math.floor(path.getLength() / 2)
    return path.getAt(index)
  }
}
